import React, { useState, useEffect, useContext } from 'react'
import { Link } from "react-router-dom"
import axiosJWT from './JwtToken'
import ChatComponent from './chat/ChatComponent'
import { useAuth } from './AuthContext'

function Footer() {
  const { isLoggedIn } = useAuth()
  const [profil, setProfil] = useState([])
  const [optLaporan, setOptLaporan] = useState([])

  const [msg, setMsg] = useState("")
  const [pesan, setPesan] = useState(false)
  const [showChatDrawer, setShowChatDrawer] = useState(false)
  const [activeRoomCode, setActiveRoomCode] = useState(null)
  const [activeVendorId, setActiveVendorId] = useState('')
  const [activeVendorName, setActiveVendorName] = useState('')
  const [isOpening, setIsOpening] = useState(false)

  useEffect(() => {
    getProfil()
    getLaporan()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getProfil = async () => {
    const response = await axiosJWT.get('/api/profil/publish')
    setProfil(response.data)
  }

  const getLaporan = async (filter) => {
    try {
      const response = await axiosJWT.post("/api/laporan/kategori/load", {
        key: filter,
        jml: 1000
      })
      setOptLaporan(response.data)
    } catch (err) {
      setOptLaporan([])
    }
  }

  const isJamKerja = () => {
    const jam = new Date().getHours()
    return jam >= 9 && jam < 15
  }

  const openChat = async () => {
    setIsOpening(true)
    try {
      // Panggil endpoint baru yang sudah kita buat khusus untuk Support
      const response = await axiosJWT.post("/api/chat/support-room", {
        receiverPotensialCode: 'SUPPORT DPMPTSP',
        referenceType: 'SUPPORT'
      })

      setActiveVendorId('SUPPORT DPMPTSP')
      setActiveRoomCode(response.data.roomCode)
      setActiveVendorName('KONSULTASI')
      setShowChatDrawer(true)
    } catch (err) {
      setPesan(true)
      setMsg('Gagal membuka ruang chat!')
      setTimeout(() => {
        setPesan(false)
        setMsg("")
      }, 2000)
    } finally {
      setIsOpening(false)
    }
  }

  return (
    <>
      <footer className="ms-footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-3 col-6">
              <h4 className='text-footer font-bold'>Mengapa Kota Bekasi?</h4>
              <h4>
                <Link to={"/mengapa-kota-bekasi/demografi"} className='text-footer'>Demografi</Link>
              </h4>
              <h4>
                <Link to={"/mengapa-kota-bekasi/geofrafis"} className='text-footer'>Geografis</Link>
              </h4>
              <h4>
                <a href={'https://oss.go.id'} target="_blank" rel="noopener noreferrer" className='text-footer'>OSS</a>
              </h4>
              <h4>
                <a href={'https://silat.bekasikota.go.id'} target="_blank" rel="noopener noreferrer" className='text-footer'>Aplikasi Silat</a>
              </h4>
              {/* <h4>
                <a href={'https://siibeken.bekasikota.go.id'} target="_blank" rel="noopener noreferrer" className='text-footer'>Aplikasi SiiBeken</a>
              </h4> */}
              <h4>
                <Link to={"/survey-kepuasan-masyarakat/pengalaman-investor"} className='text-footer'>Pengalaman Investor</Link>
              </h4>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-6">
              <h4 className='text-footer font-bold'>Layanan dan Pegaduan</h4>
              <h4>
                <Link to={"/layanan-dan-pengaduan/prosedur/memulai-bisnis"} className='text-footer'>Prosedur</Link>
              </h4>
              <h4>
                <Link to={"/layanan-dan-pengaduan/prosedur/pelayanan"} className='text-footer'>Pelayanan</Link>
              </h4>
              <h4>
                <Link to={"/layanan-dan-pengaduan/prosedur/pengaduan"} className='text-footer'>Pengaduan</Link>
              </h4>
              <h4>
                <Link to={"/layanan-dan-pengaduan/prosedur/panduan"} className='text-footer'>Panduan</Link>
              </h4>
              <h4>
                <Link to={"/layanan-dan-pengaduan/prosedur/open-data"} className='text-footer'>Open Data</Link>
              </h4>
              <h4>
                <Link to={"/layanan-dan-pengaduan/prosedur/hubungi-kami"} className='text-footer'>Hubungi Kami</Link>
              </h4>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-6">
              <h4 className='text-footer font-bold'>Info</h4>
              <h4>
                <Link to={"/info/siaran-pers"} className='text-footer'>Siaran Pers</Link>
              </h4>
              <h4>
                <Link to={"/info/artikel-publikasi"} className='text-footer'>Artikel dan Publikasi</Link>
              </h4>
              <h4>
                <Link to={"/info/galeri"} className='text-footer'>Galeri</Link>
              </h4>
              <h4>
                <Link to={"/info/pengumuman"} className='text-footer'>Pengumuman</Link>
              </h4>
              <h4>
                <Link to={"/info/agenda-kegiatan"} className='text-footer'>Agenda Kegiatan</Link>
              </h4>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-6">
              <h4 className='text-footer font-bold'>Laporan</h4>
              {optLaporan.map((val, i) => (
                <h4 key={i}>
                  <Link to={`/laporan/${val.namaKategori.replaceAll(' ', '-')}`} className='text-footer'>{val.namaKategori.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}</Link>
                </h4>
              ))}
            </div>
            <div className="col-lg-12 col-md-12">
              <hr></hr>
            </div>
            <div className="col-lg-4 col-md-4 ms-footer-col ms-footer-text-left">
              <div className="mt-0 mb-2">
                <address className="no-mb">
                  <ul className='list-unstyled ms-icon-list three_cols'>
                    <li>
                      <Link to={"/privasi-pengguna"} className='text-footer font-bold'>Privasi</Link>
                    </li>
                    <li>
                      <Link to={"/ketentuan-penggunaan"} className='text-footer font-bold'>Ketentuan</Link>
                    </li>
                    <li>
                      <Link to={"/peta-situs"} className='text-footer font-bold'>Peta Situs</Link>
                    </li>
                  </ul>
                </address>
              </div>
            </div>
            <div className="col-lg-8 col-md-8 ms-footer-col ms-footer-text-right">
              <div className="mt-0 mb-2">
                <address className="no-mb">
                  <p><i className="zmdi zmdi-email mr-1"></i> Email: <a className="text-footer font-bold" href={`mailto: ${profil.email}`}>{profil.email}</a></p>
                  <p><i className="zmdi zmdi-phone mr-1"></i> Telepon: {profil.telp} </p>
                </address>
              </div>
            </div>
            <div className="col-lg-9 col-md-9 ms-footer-col ms-footer-text-left">
              <p>&copy; {new Date().getFullYear()} Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kota Bekasi , Semua Hak Cipta dilindungi undang-undang</p>
              {profil.alamat}, {profil.kota}, {profil.kd_pos}
            </div>
            <div className="col-lg-3 col-md-3 ms-footer-col ms-footer-text-right">
              <div className="ms-footbar-block">
                <div className="ms-footbar-social">
                  <a href={profil.facebook} className="btn-circle btn-facebook"><i className="zmdi zmdi-facebook"></i></a>
                  <a href={profil.twitter} className="btn-circle btn-twitter"><i className="zmdi zmdi-twitter"></i></a>
                  <a href={profil.youtube} className="btn-circle btn-youtube"><i className="zmdi zmdi-youtube-play"></i></a>
                  <a href={profil.instagram} className="btn-circle btn-instagram"><i className="zmdi zmdi-instagram"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="btn-back-top back-show">
        {isJamKerja() && (
          isLoggedIn ? (
            // JIKA LOGIN & JAM KERJA
            <button onClick={() => openChat()} className="btn btn-raised btn-info btn-sm br-2 mt-1">
              {isOpening ? "Memproses..." : <><i className="fa fa-comments"></i> Konsultasi</>}
            </button>
          ) : (
            <Link to={"/login"} className="btn btn-raised btn-danger btn-sm br-2 mt-1">
              <i className="fa fa-comments"></i> Konsultasi
            </Link>
          )
        )}
        <a href="#" data-scroll="" id="back-top" className="btn-circle btn-circle-primary btn-circle-sm btn-circle-raised "><i className="zmdi zmdi-long-arrow-up"></i></a>
      </div>

      {showChatDrawer && (
        <>
          <div className={'chat-canvas'}>
            <div className="bg-primary p-3 text-white d-flex justify-content-between">
              <span>{activeVendorName}</span>
              <button className="btn btn-raised btn-xs btn-danger" onClick={() => setShowChatDrawer(false)}>X</button>
            </div>
            <div style={{ height: 'calc(100% - 50px)' }}>
              {/* PANGGIL KOMPONEN CHAT KITA DI SINI */}
              <ChatComponent
                roomCode={activeRoomCode}
                targetUser={activeVendorId}
              />
            </div>
          </div>
          <div className="modal-backdrop fade in" onClick={() => setShowChatDrawer(false)} style={{ zIndex: 1069 }}></div>
        </>
      )}

      <div className={pesan ? "modal-open" : ""}>
        <div style={{ display: pesan ? "block" : "none" }} className={pesan ? "modal modal-primary show" : "modal modal-primary"} id="myData" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog center">
            <div className="modal-content modal-sm">
              <div className="modal-header header-modal-primary p-1">
                <h4 className="modal-title text-center no-p font-bold">PESAN</h4>
              </div>
              <div className="modal-body text-center">
                <h4 className="font-bold">{msg.toUpperCase()}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      {pesan ? <div className="modal-backdrop fade in"></div> : ""}
    </>
  )
}

export default Footer